import React from "react";
export default function PricingTable() {
  return (
    <div style={{ paddingBottom: "200px" }}>
      <stripe-pricing-table pricing-table-id={process.env.REACT_APP_STRIPE_PT_ID} publishable-key={process.env.REACT_APP_STRIPE_PT_KEY}></stripe-pricing-table>
    </div>
  );
}
